var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSideMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-panel-right-open",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3v18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 15-3-3 3-3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSideMenu);
export default __webpack_public_path__ + "static/media/closeSideMenu.24d2839846e15444c1acd5fb48d30d79.svg";
export { ForwardRef as ReactComponent };